import { useToast as usePrimeToast } from 'primevue/usetoast'
import { GetPipelineStatus, Publish } from './git'
import { computed, ref } from 'vue'
import type { gitPipelineStatus } from '../types/cmsTypes'

export function usePublish() {
  const toast = usePrimeToast()
  const publishStatus = ref<gitPipelineStatus>(null)
  const blockPublish = ref(true)
  const lastPublishFailed = ref(false)

  const just_published = ref(false)

  const GetPublishStatus = async () => {
    if (just_published.value) {
      return
    }
    const res = await GetPipelineStatus()
    if (!res.status_ok) {
      // toast.add({
      //   severity: 'error',
      //   summary: 'Error',
      //   detail: 'Nie udało się pobrac statusu publikowania',
      //   life: 3000
      // })
      return
    }
    const status = res.data as gitPipelineStatus ?? null
    publishStatus.value = status
    lastPublishFailed.value = status === 'failed'
    blockPublish.value = !res.status_ok || !status || ['waiting_for_resource', 'preparing', 'pending', 'running'].includes(status)
  }

  const publishIcon = computed(() => {
    if (!publishStatus.value) {
      return 'pi pi-circle-fill color-gray'
    }
    if (['waiting_for_resource', 'preparing', 'pending', 'running'].includes(publishStatus.value)) {
      return 'pi pi-circle-fill color-orange p-pulsing'
    }
    if (lastPublishFailed.value) {
      return 'pi pi-circle-fill color-red p-pulsing'
    }
    return 'pi pi-circle-fill color-green'
  })

  const getPublishLabel = () => {
    if (!publishStatus.value) {
      return 'Loading Status...' + (lastPublishFailed.value ? ' (Last Publish failed)' : '')
    }
    if (['waiting_for_resource', 'preparing', 'pending', 'running'].includes(publishStatus.value)) {
      return 'Publishing' + (lastPublishFailed.value ? ' (Last Publish failed)' : '')
    }
    return 'Ready to Publish' + (lastPublishFailed.value ? ' (Last Publish failed)' : '')
  }

  const publishPage = async () => {
    await GetPublishStatus()
    if (publishStatus.value && !['waiting_for_resource', 'preparing', 'pending', 'running'].includes(publishStatus.value)) {
      blockPublish.value = true
      publishStatus.value = 'running'
      const res = await Publish()
      if (!res.status_ok) {
        toast.add({
          severity: 'error',
          summary: 'Error',
          detail: res.message,
          life: 3000
        })
      }
      just_published.value = true
      setTimeout(async () => {
        await GetPublishStatus()
        just_published.value = false
      }, 5000)
    }
  }

  return {
    publishStatus,
    blockPublish,
    lastPublishFailed,
    GetPublishStatus,
    publishIcon,
    getPublishLabel,
    publishPage
  }
}
